export default __webpack_public_path__ + "static/media/347.65895b9f.jpg";